/*
* 处理人员管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Button,
    Input,
    DatePicker,
    Select,
    Space,
    theme,
    Tag,
    Statistic,
} from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    isGTscreenWidth,
    rootReactDom,
    GetButtonActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import WODouserEntity from './WODouserEntity';

/** 
* 日期样式
*/
import locale from 'antd/es/date-picker/locale/zh_CN';

const MODULENAME = CNF.navItems[2].submenu[2].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[2].submenu[2].ptn;

const { RangePicker } = DatePicker;

const Lists = (props) => {

    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            colorSuccess,
            colorSuccessBg,

        },
    } = theme.useToken();

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'wo/dousers/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, props.isRefresh, uri);
                break;
            default:
                break;

        }
    }

    const update = (record) => {
        rootReactDom?.render(
            <WODouserEntity
                record={record}
                isRefresh={props.isRefresh}
            />);
    }

    const columns = [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        { title: '工单编号', dataIndex: 'number', key: 'number', fixed: 'left', width: 150, },
        {
            title: '工单等级', key: 'level', fixed: 'left',
            render: function (record) {
                for (let item of CNF.woLevels) {
                    if (parseInt(record.level) === parseInt(item.value)) {
                        return item.key
                    }
                }
            }
        },
        { title: '工单类型', dataIndex: 'type', key: 'type', },
        {
            title: '绩效权重', key: 'weight',
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.weight} /></Tag>
        },
        {
            title: '绩效分值', key: 'perf_value',
            render: (record) => <Tag color={colorSuccessBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={record.perf_value} /></Tag>
        },
        { title: '处理人员', dataIndex: 'do_user', key: 'do_user', },
        { title: '开始时间', dataIndex: 'start_time', key: 'start_time', },
        { title: '结束时间', dataIndex: 'end_time', key: 'end_time', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetButtonActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            number: '',
            douser: '',
            level: 0,
            type: '',
            startDate: '',
            endDate: '',

        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeNumber = (e) => { this.setState({ number: e.target.value, }); this.search(); }
    changeDouser = (e) => { this.setState({ douser: e.target.value, }); this.search(); }
    changeLevel = (value) => { this.setState({ level: value, }); this.search(); }
    changeType = (value) => { this.setState({ type: value, }); this.search(); }
    changeTimeInterval = (_, dateString) => { this.setState({ startDate: dateString[0], endDate: dateString[1], }); this.search(); };
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'number': this.state.number,
            'do_user': this.state.douser,
            'level': this.state.level,
            'type': this.state.type,
            'start_date': this.state.startDate,
            'end_date': this.state.endDate,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}wo/dousers${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
    * 导出 Excel
    */
    exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '人员处理明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '人员处理明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '工单编号',
                    '工单等级',
                    '工单类型',
                    '绩效权重',
                    '绩效分值',
                    '处理人员',
                    '开始时间',
                    '结束时间',
                    '调整说明'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 导出明细
     */
    export() {
        const _this = this
        const params = {
            'number': this.state.number,
            'do_user': this.state.douser,
            'level': this.state.level,
            'type': this.state.type,
            'start_date': this.state.startDate,
            'end_date': this.state.endDate,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}wo/dousers${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['wo_ulid'];
                            delete item['create_username']
                            delete item['create_displayname']
                            delete item['create_time']
                            delete item['update_time']
                            for (let i of CNF.woLevels) {
                                if (parseInt(item['level']) === parseInt(i.value)) {
                                    item['level'] = i.key
                                }
                            }
                            d.push(item);
                        }
                        _this.exportAsExcel(d);
                    } else {
                        _this.exportAsExcel([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 2 : 3}>
                        <Input
                            placeholder='工单编号'
                            onChange={this.changeNumber}
                            value={this.state.number}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft, }}>
                        <Input
                            placeholder='处理人员'
                            onChange={this.changeDouser}
                            value={this.state.douser}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                        <Select
                            allowClear
                            placeholder='工单等级'
                            style={{ width: '100%' }}
                            onChange={this.changeLevel}
                            value={this.state.level > 0 ? this.state.level : undefined}
                            options={CNF.woLevels.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.key
                            }))}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                        <Select
                            allowClear
                            placeholder='工单类型'
                            style={{ width: '100%' }}
                            onChange={this.changeType}
                            value={this.state.type ? this.state.type : undefined}
                            options={CNF.woTypes.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.key
                            }))}
                        />
                    </Col>
                    <Col span={4} style={{ marginLeft: CNF.searchMarginLeft, }}>
                        <RangePicker
                            placeholder={['开始日期', '结束日期']}
                            style={{ width: '100%' }}
                            locale={locale}
                            format='YYYY-MM-DD'
                            onChange={this.changeTimeInterval}
                        />
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.export();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                    </Space>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT